import { NgModule } from '@angular/core';
import { ProductionDetailsSearchComponent } from './production-details-search/production-details-search.component';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProductionRoutingModule } from './production-routing.module';
import { ProductionService } from './services/production.service';
import { TeamProductionDetailsSearchComponent } from './team-production-details-search/team-production-details-search.component';

@NgModule({
  declarations: [ProductionDetailsSearchComponent, TeamProductionDetailsSearchComponent],
  imports: [CommonModule, SystemCommonModule, ProductionRoutingModule, ModalModule.forRoot()],
  providers: [ProductionService],
})
export class ProductionModule {}
